import { Inject, inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable, of, take, timeout } from 'rxjs';
import { AUTH_STATE } from '../firebase.providers';
import { User } from 'firebase/auth';

// Keeps guest-only screens (login, register) out of reach once signed in. Uses
// authState, whose first emission is the resolved state after a page refresh, so a
// logged-in user is redirected rather than shown the form. The timeout fails open:
// if auth state can't be determined quickly, show the page rather than block it.
@Injectable({
  providedIn: 'root',
})
export class GuestCheckService {
  constructor(
    @Inject(AUTH_STATE) private authState: Observable<User | null>,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authState.pipe(
      take(1),
      timeout({ first: 3000, with: () => of(null) }),
      map((user) =>
        user && user.emailVerified ? this.router.parseUrl('/start') : true,
      ),
    );
  }
}

export const GuestGuard: CanActivateFn = () =>
  inject(GuestCheckService).canActivate();
